import { render, staticRenderFns } from "./listTextDetial.vue?vue&type=template&id=abc4e930&scoped=true"
import script from "./listTextDetial.vue?vue&type=script&lang=js"
export * from "./listTextDetial.vue?vue&type=script&lang=js"
import style0 from "./listTextDetial.vue?vue&type=style&index=0&id=abc4e930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc4e930",
  null
  
)

export default component.exports